export default __webpack_public_path__ + "static/gray-still-plays-7bd14d70a579fc7b812e6d9100be4272.mp4";